<template>
  <nav class="w-[70%] top-0 left-0 h-screen bg-white z-20 overflow-y-auto relative" :class="start ? 'show-menu' : 'hide-menu' ">
    <ul class="flex flex-col font-medium mt-12">
      <li class="flex flex-col px-4 py-4 border-b-2" v-for="(item) in nav" :key="item.nombre">
        <router-link class="flex" :class="item.items.length ? 'pointer-events-none text-text-color-dark pb-1' : null" :to="item.path" :exact="item.path === '/'">
          <span class="flex items-center">{{item.nombre}} <ChevronDown v-if="item.items.length"/></span>
        </router-link>
        <ul v-if="item.items.length" class="">
          <li class="flex px-4" v-for="subItem in item.items" :key="subItem.nombre">
            <router-link class="flex py-3 w-full" :to="`${item.path}/${subItem.path}`">{{subItem.nombre}}</router-link>
          </li>
        </ul>
      </li>
      <li class="flex flex-col px-4 py-4 border-b-2" v-if="eventos && eventos.length">
        <span class="flex items-center pointer-events-none text-text-color-dark pb-1">Eventos <ChevronDown /></span>
        <ul class="">
          <li class="flex px-4" v-for="evento in eventosOrdenados" :key="evento.id">
            <a @click="changeEvento(evento)" :class="{ 'text-theme-color': eventoSeleccionado.id === evento.id }" class="flex py-3 w-full cursor-pointer">{{ evento.nombre }}</a>
          </li>
          <li class="flex px-4">
            <a href="/es/2020/" class="flex py-3 w-full">III CICI 2020</a>
          </li>
          <li class="flex px-4">
            <a href="/es/2018/" class="flex py-3 w-full">II CICI 2018</a>
          </li>
          <li class="flex px-4">
            <a href="/es/2016/" class="flex py-3 w-full">I CICI 2016</a>
          </li>
        </ul>
      </li>
    </ul>
    <Close class="absolute right-0 top-0 p-4" @click="onClicked" :size="35" />
  </nav>
</template>

<script>
import {mapMutations, mapGetters} from "vuex"
import ChevronDown from 'vue-material-design-icons/ChevronDown.vue';
import Close from 'vue-material-design-icons/Close.vue';

  export default {
    components: {
      ChevronDown,
      Close
    },

    props: ["nav", "eventos", "isActive"],

    data(){
      return {
        start: false
      }
    },

    computed: {
      ...mapGetters(["eventoSeleccionado"]),
      eventosOrdenados() {
        if (!this.eventos) return [];
        return [...this.eventos].sort((a, b) => b.id - a.id);
      },
    },

    methods: {
      ...mapMutations(["setIdEventoActual"]),

      onClicked(){
        this.start = false;
        setTimeout(() => {
          this.$emit('closeDrawer')

        }, 700);
      },

      changeEvento(evento){
        const currentQuery = (this.$route.query.evento || '').toString();
        const newQuery = evento.id.toString();

        if (newQuery !== currentQuery) {
          this.setIdEventoActual(evento.id);
          this.$router.push({ path: '/', query: { evento: evento.id } });
          window.location.reload();
        }

        this.onClicked();
      }
    },

    watch:{
      isActive: {
        immediate: true,
        handler(newValue) {
          this.start = newValue;
        }
      }
    }
  };
</script>

<style scoped>
.router-link-active {
  @apply text-theme-color;
}

.show-menu {
  animation: slide-in 1.2s;
}

.hide-menu {
  animation: slide-out 1.2s;
}

@keyframes slide-in {
  0% {
    left: -100%;
  }
  100% {
    left: 0;
  }
}

@keyframes slide-out {
  0% {
    left: 0;
  }
  100% {
    left: -100%;
  }
}
</style>
